export default __webpack_public_path__ + "static/media/contacts-loading.ca0f7b77.gif";